import { createTheme, responsiveFontSizes } from "@mui/material/styles";

let theme = createTheme({
  palette: {
    primary: {
      main: "#7c5cff", // Soft purple
      light: "#f3e6fa", // Light lavender for cards/boxes
      contrastText: "#fff",
    },
    secondary: {
      main: "#f9c6d1", // Soft pink accent
    },
    background: {
      default: "#f9f6ea", // Cream background
      paper: "#fffdfa", // Slightly off-white for cards
    },
    text: {
      primary: "#2d223a", // Deep, friendly purple-black
      secondary: "#6d5a7b", // Muted purple-grey
    },
  },
  typography: {
    fontFamily:
      "'Nunito', 'Open Sans', 'Arial Rounded MT Bold', Arial, sans-serif",
    h1: {
      fontFamily: "'Nunito', 'Open Sans', sans-serif",
      fontWeight: 800,
      fontSize: "2.5rem",
      lineHeight: 1.2,
    },
    h2: {
      fontFamily: "'Nunito', 'Open Sans', sans-serif",
      fontWeight: 700,
      fontSize: "2rem",
      lineHeight: 1.25,
    },
    h3: {
      fontFamily: "'Nunito', 'Open Sans', sans-serif",
      fontWeight: 700,
      fontSize: "1.5rem",
      lineHeight: 1.3,
    },
    h4: {
      fontFamily: "'Nunito', 'Open Sans', sans-serif",
      fontWeight: 700,
      fontSize: "1.25rem",
    },
    h5: {
      fontFamily: "'Nunito', 'Open Sans', sans-serif",
      fontWeight: 600,
      fontSize: "1.1rem",
    },
    h6: {
      fontFamily: "'Nunito', 'Open Sans', sans-serif",
      fontWeight: 600,
      fontSize: "1rem",
    },
    body1: {
      fontFamily: "'Open Sans', 'Nunito', sans-serif",
      fontWeight: 400,
      fontSize: "1rem",
    },
    body2: {
      fontFamily: "'Open Sans', 'Nunito', sans-serif",
      fontWeight: 400,
      fontSize: "0.95rem",
    },
    button: {
      fontFamily: "'Nunito', 'Open Sans', sans-serif",
      fontWeight: 700,
      textTransform: "none",
      fontSize: "1.1rem",
    },
  },
  shape: {
    borderRadius: 16, // Extra rounded corners
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          fontWeight: 700,
          boxShadow: "0 2px 8px 0 rgba(124,92,255,0.08)",
          paddingTop: 12,
          paddingBottom: 12,
        },
        contained: {
          backgroundColor: "#7c5cff",
          color: "#fff",
          "&:hover": {
            backgroundColor: "#6a4fd1",
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          boxShadow: "0 2px 16px 0 rgba(124,92,255,0.07)",
          backgroundColor: "#fffdfa",
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          backgroundColor: "#f3e6fa",
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          borderRadius: 16,
        },
      },
    },
  },
});

theme = responsiveFontSizes(theme);

export default theme;
